export default {
    webhooksList: {},
    webhooksFields: [
        {
            key: 'title',
            label: 'Title',
            sortable: true,
        },
        {
            key: 'endpointUrl',
            label: 'Endpoint URL',
            sortable: true,
        },
        {
            key: 'triggerPoint',
            label: 'Trigger Point',
            sortable: true,
        },
        {
            key: 'description',
            label: 'Description',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
            class: 'text-center status-absolute-pos',
        },
        {
            key: 'action',
            label: 'Action',
            tdClass: 'user-roles-action',
        },
    ],
}
